module.exports = __webpack_public_path__ + "img/8.87999331.jpg";